ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
Modal = require 'components/common/modal'
OutcomesSelect = require 'components/common/outcomes_select'
Select = require 'components/common/select'
CheckboxInput = require 'components/common/checkbox_input'
ConnectStore = require 'components/enhancers/connect_store'
NMAListActions = require 'actions/nma_list_actions'
NMAListStore = require 'stores/nma_list_store'
NMAQuestionStore = require 'stores/nma_question_store'
QuestionsStore = require 'stores/questions_store'
mediator = require 'mediator'
useTranslation = require 'components/hooks/use_translation'
{ insertGdtTable } = require 'lib/epiditor_utils'
{
  COMPARISON_ACROSS_OUTCOMES
  OUTCOME_ACROSS_COMPARISONS
  buildThresholdPlotData
  getRowId
} = require 'lib/threshold_plot_helper'
{ useEffect, useState } = React
{ PMView } = Epiditor

sourceValue = (sourceType, qId) -> "#{sourceType}:#{qId}"

parseSourceValue = (value) ->
  [sourceType, qId] = value.split ':'
  { sourceType, qId }

storeConnector =
  NMAListStore: (Store) ->
    isFetchingNmaQuestions: Store.isFetching()
    nmaQuestions: Store.getQuestions()
  NMAQuestionStore: (Store) ->
    nmaOutcomes: Store.getOutcomes()
  QuestionsStore: (Store) ->
    regularQuestions: Store.getQuestions()

ThresholdPlotInsertModal = ({
  isFetchingNmaQuestions
  nmaOutcomes
  nmaQuestions
  onClose
  onInsert
  regularQuestions
}) ->
  i18n = useTranslation ''
  [selectedSource, setSelectedSource] = useState null
  [plotMode, setPlotMode] = useState COMPARISON_ACROSS_OUTCOMES
  [comparisonKey, setComparisonKey] = useState null
  [outcomeId, setOutcomeId] = useState null
  [selectedOutcomeIds, setSelectedOutcomeIds] = useState null
  [selectedComparisonKeys, setSelectedComparisonKeys] = useState null
  [includeNetEffect, setIncludeNetEffect] = useState true

  useEffect(
    ->
      shouldFetch = not isFetchingNmaQuestions and
        (nmaQuestions.isEmpty() or nmaOutcomes.isEmpty())
      return undefined unless shouldFetch

      cancelled = false
      _.defer ->
        return if cancelled
        NMAListActions.fetchAllQuestionsAndOutcomes dbId: mediator.project.id

      ->
        cancelled = true
    [isFetchingNmaQuestions, nmaQuestions, nmaOutcomes]
  )

  regularSourceOptions = regularQuestions
    .map (question) ->
      value: sourceValue 'regular', question.get('_id')
      text: question.get('question')
    .toList()
    .toArray()

  nmaSourceOptions = nmaQuestions
    .map (question) ->
      value: sourceValue 'nma', question.get('_id')
      text: "#{question.get('question')} (#{i18n 'nma:common_comparator_table.nma'})"
    .toArray()

  sourceOptions = regularSourceOptions.concat nmaSourceOptions

  effectiveSource = selectedSource ? sourceOptions[0]?.value
  source = parseSourceValue effectiveSource if effectiveSource

  plotData = if source
    buildThresholdPlotData _.extend {}, source, {
      regularQuestions
      nmaQuestions
      nmaOutcomes
    }

  comparisonOptions = (plotData?.data ? []).map (comparison) ->
    value: getRowId comparison
    text: i18n 'nma:common_comparator_table.intervention_vs_comparator',
      intervention: comparison.rowElement?.name
      comparator: comparison.comparator?.name

  outcomeOptions = (plotData?.outcomes ? []).map (outcome) ->
    value: outcome.id
    text: outcome.name

  isRegularSource = source?.sourceType is 'regular'
  availableOutcomeIds = outcomeOptions.map (option) -> option.value
  availableComparisonKeys = comparisonOptions.map (option) -> option.value
  effectiveComparisonKey = if comparisonKey in availableComparisonKeys
    comparisonKey
  else
    comparisonOptions[0]?.value
  effectiveOutcomeId = if outcomeId in availableOutcomeIds
    outcomeId
  else
    outcomeOptions[0]?.value
  effectiveSelectedOutcomeIds = if selectedOutcomeIds?
    selectedOutcomeIds.filter (outcomeId) -> outcomeId in availableOutcomeIds
  else
    availableOutcomeIds
  effectiveSelectedComparisonKeys = if selectedComparisonKeys?
    selectedComparisonKeys.filter (comparisonKey) -> comparisonKey in availableComparisonKeys
  else
    availableComparisonKeys

  outcomeSelectItems = Immutable.fromJS outcomeOptions.map (outcome) ->
    _id: outcome.value
    name: outcome.text

  comparisonSelectItems = Immutable.fromJS comparisonOptions.map (comparison) ->
    _id: comparison.value
    name: comparison.text

  updateSelectedOutcomes = (selectedOutcomes) ->
    setSelectedOutcomeIds selectedOutcomes.toArray()

  updateSelectedComparisons = (selectedComparisons) ->
    setSelectedComparisonKeys selectedComparisons.toArray()

  toggleIncludeNetEffect = (e) ->
    setIncludeNetEffect e.currentTarget.checked

  submit = ->
    return unless source
    effectivePlotMode = if isRegularSource then COMPARISON_ACROSS_OUTCOMES else plotMode
    selectedOutcomeIdsToInsert = if effectivePlotMode is COMPARISON_ACROSS_OUTCOMES
      effectiveSelectedOutcomeIds
    else
      []
    selectedComparisonKeysToInsert = if effectivePlotMode is OUTCOME_ACROSS_COMPARISONS
      effectiveSelectedComparisonKeys
    else
      []
    includeNetEffectToInsert = if effectivePlotMode is COMPARISON_ACROSS_OUTCOMES
      includeNetEffect
    else
      true
    selectedComparisonTitle = _.findWhere(comparisonOptions, value: effectiveComparisonKey)?.text
    selectedOutcomeTitle = _.findWhere(outcomeOptions, value: effectiveOutcomeId)?.text
    title = if effectivePlotMode is OUTCOME_ACROSS_COMPARISONS
      selectedOutcomeTitle
    else
      selectedComparisonTitle
    title ?= i18n 'editor.insert_threshold_plot'
    onInsert
      type: 'threshold_plot'
      sourceType: source.sourceType
      qId: source.qId
      plotMode: effectivePlotMode
      comparisonKey: effectiveComparisonKey
      outcomeId: effectiveOutcomeId
      selectedOutcomeIds: selectedOutcomeIdsToInsert
      selectedComparisonKeys: selectedComparisonKeysToInsert
      includeNetEffect: includeNetEffectToInsert
      data:
        title: title
        sourceType: source.sourceType
        qId: source.qId
        plotMode: effectivePlotMode
        comparisonKey: effectiveComparisonKey
        outcomeId: effectiveOutcomeId
        selectedOutcomeIds: selectedOutcomeIdsToInsert
        selectedComparisonKeys: selectedComparisonKeysToInsert
        includeNetEffect: includeNetEffectToInsert

  sourceDisabled = sourceOptions.length is 0
  plotDisabled = not plotData?.data?.length
  outcomesRequired = isRegularSource or plotMode is COMPARISON_ACROSS_OUTCOMES
  outcomeDisabled = outcomesRequired and effectiveSelectedOutcomeIds.length is 0
  comparisonDisabled = plotMode is OUTCOME_ACROSS_COMPARISONS and effectiveSelectedComparisonKeys.length is 0
  submitDisabled = sourceDisabled or plotDisabled or outcomeDisabled or comparisonDisabled

  <Modal isOpen
    className='etd-insert-modal'
    onClose={onClose}
    title={i18n 'editor.insert_threshold_plot'}
    closeButton
  >
    <div>
      <div className="insert-options">
        <div className="mb-10">
          <span>{i18n 'editor.source_question'}:</span>
          <Select
            options={sourceOptions}
            selected={effectiveSource}
            onChange={setSelectedSource}
            style={width: '100%'}
          />
        </div>
        {if isRegularSource
          <div className="mb-10 ">
            <span>{i18n 'editor.outcomes'}:</span>
            <div className="threshold-plot-outcomes-list insert-options">
              <OutcomesSelect
                key={"regular-outcomes-#{effectiveSource}"}
                outcomes={outcomeSelectItems}
                selectedOutcomes={Immutable.List effectiveSelectedOutcomeIds}
                updateSelectedOutcomes={updateSelectedOutcomes}
              />
            </div>
          </div>
        else
          <div>
            <div className="mb-10">
              <span>{i18n 'editor.threshold_plot_mode'}:</span>
              <Select
                options={[
                  { value: COMPARISON_ACROSS_OUTCOMES, text: i18n 'editor.comparison_across_outcomes' }
                  { value: OUTCOME_ACROSS_COMPARISONS, text: i18n 'editor.outcome_across_comparisons' }
                ]}
                selected={plotMode}
                onChange={setPlotMode}
                style={width: '100%'}
              />
            </div>
            {plotMode is COMPARISON_ACROSS_OUTCOMES and
              <div>
                <div className="mb-10">
                  <span>{i18n 'editor.comparison'}:</span>
                  <Select
                    options={comparisonOptions}
                    selected={effectiveComparisonKey}
                    onChange={setComparisonKey}
                    style={width: '100%'}
                  />
                </div>
                <div className="mb-10 ">
                  <span>{i18n 'editor.outcomes'}:</span>
                  <div className="threshold-plot-outcomes-list insert-options">
                    <OutcomesSelect
                      key={"nma-outcomes-#{effectiveSource}"}
                      outcomes={outcomeSelectItems}
                      selectedOutcomes={Immutable.List effectiveSelectedOutcomeIds}
                      updateSelectedOutcomes={updateSelectedOutcomes}
                    />
                  </div>
                </div>
                <div className="mb-10">
                  <label>
                    <CheckboxInput
                      checked={includeNetEffect}
                      onChange={toggleIncludeNetEffect}
                    />
                    {i18n 'editor.include_net_effect'}
                  </label>
                </div>
              </div>
            }
            {plotMode is OUTCOME_ACROSS_COMPARISONS and
              <div>
                <div className="mb-10">
                  <span>{i18n 'editor.outcome'}:</span>
                  <Select
                    options={outcomeOptions}
                    selected={effectiveOutcomeId}
                    onChange={setOutcomeId}
                    style={width: '100%'}
                  />
                </div>
                <div className="mb-10">
                  <span>{i18n 'editor.comparisons'}:</span>
                  <div className="threshold-plot-outcomes-list">
                    <OutcomesSelect
                      key={"comparisons-#{effectiveSource}"}
                      outcomes={comparisonSelectItems}
                      selectedOutcomes={Immutable.List effectiveSelectedComparisonKeys}
                      updateSelectedOutcomes={updateSelectedComparisons}
                    />
                  </div>
                </div>
              </div>
            }
          </div>
        }
        {sourceDisabled and <div className="error">{i18n 'editor.no_nma_questions'}</div>}
        {plotDisabled and <div className="error">{i18n 'editor.threshold_plot_no_data'}</div>}
      </div>
      <ApplyCancelButtons
        onApply={submit}
        onCancel={onClose}
        isSubmitEnabled={not submitDisabled}
        applyLabel={i18n 'actions.insert'}
      />
    </div>
  </Modal>

ConnectedThresholdPlotInsertModal = ConnectStore ThresholdPlotInsertModal,
  [QuestionsStore, NMAListStore, NMAQuestionStore],
  storeConnector

ThresholdPlotInsertControl = ({ view, onCloseMenu }) ->
  i18n = useTranslation ''
  [isModalOpen, setIsModalOpen] = useState false
  canInsert = insertGdtTable(view.state)({})

  closeModal = ->
    setIsModalOpen false
    onCloseMenu()

  handleInsert = (content) ->
    view.focus()
    insertGdtTable(view.state, view.dispatch)(content)
    closeModal()

  handleClick = (evt) ->
    evt.preventDefault()
    evt.stopPropagation()
    setIsModalOpen true

  <div>
    <div
      className={classNames 'gdt-table-insert-toggle', disabled: !canInsert}
      onMouseDown={handleClick if canInsert}
    >
      <span>{i18n 'actions.insert_threshold_plot'}</span>
    </div>
    {isModalOpen and
      <ConnectedThresholdPlotInsertModal
        onClose={closeModal}
        onInsert={handleInsert}
      />
    }
  </div>

ThresholdPlotInsertControl.propTypes =
  view: PropTypes.instanceOf(PMView.EditorView).isRequired

module.exports = ThresholdPlotInsertControl
